import { Flex, Image } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getLanguageFromStorage, saveLanguageToStorage } from 'src/modules/internationalization/helpers/handleStorage'
import { validateLanguage } from 'src/modules/internationalization/helpers/validateLanguage'

const languagesOptions = [
  {
    label: 'Português',
    value: 'pt-BR',
    flag: 'assets/images/flag-brazil.svg',
  },
  {
    label: 'Español',
    value: 'es',
    flag: 'assets/images/flag-spain.svg',
  },
]

export function ChooseLanguageModal() {
  const [language, setLanguage] = useState('pt-BR')

  const { i18n } = useTranslation()

  useEffect(() => {
    const userHasLanguageSet = getLanguageFromStorage()
    if (!userHasLanguageSet) return
    const isLanguageValid = validateLanguage(userHasLanguageSet)
    if (!isLanguageValid) return
    setLanguage(userHasLanguageSet)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!validateLanguage(language)) {
      i18n?.changeLanguage('pt-BR')
      saveLanguageToStorage('pt-BR')
    } else {
      i18n?.changeLanguage(language)
      saveLanguageToStorage(language)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <Flex gap='16px' align='center'>
      {languagesOptions.map((opt) => (
        <Flex
          flexDir='column'
          align='center'
          justify='center'
          cursor='pointer'
          pb='2px'
          transition='all 300ms ease'
          borderColor={language === opt.value ? 'primaryColors.400' : 'transparent'}
          borderBottomWidth='2px'
          borderRadius='2px'
          onClick={() => setLanguage(opt.value)}
        >
          <Image src={opt.flag} alt='spain flag' width={5} height={5} />
        </Flex>
      ))}
    </Flex>
  )
}
